// 文件
import file from './file.js';
// 图片-服务
export default {
    /**
     * 获取本地图片地址，可以用img标签加载
     *
     * @param file 图片文件
     */
    path(file) {
        var path = null;
        if (window.createObjectURL != undefined) {
            // basic
            path = window.createObjectURL(file);
        } else if (window.URL != undefined) {
            // mozilla(firefox)
            path = window.URL.createObjectURL(file);
        } else if (window.webkitURL != undefined) {
            // webkit or chrome
            path = window.webkitURL.createObjectURL(file);
        }
        return path;
    },

    /**
     * 选择图片
     *
     * @param count 数量
     */
    choose(count = 1) {
        return file.choose('image', count);
    },

    /**
     * 预览图片
     */
    preview() {

    },
}



// WEBPACK FOOTER //
// ./src/assets/plugin/prototypes/modules/image.js